import { createSlice } from '@reduxjs/toolkit';

const csrfSlice = createSlice({
    name: 'csrf',
    initialState: {
      csrfHeaderName: '',
      csrfFormTagName: '',
      csrfToken: '',
    },
    reducers: {
      setCSRFInfo: (state, action) => {
        const { csrfHeaderName, csrfFormTagName, csrfToken } = action.payload;
        state.csrfHeaderName = csrfHeaderName;
        state.csrfFormTagName = csrfFormTagName;
        state.csrfToken = csrfToken;
      },
    },
  },
);

export const { setCSRFInfo } = csrfSlice.actions;
export default csrfSlice.reducer;